/*
 *   Copyright (c) 2023 
 *   All rights reserved.
 */
import Joi from "joi";

export const forgotSchema = Joi.object({
  email: Joi.string()
    .email({ tlds: { allow: false } })
    .required()
    .messages({
      "string.email": "Enter a valid email",
      "any.required": "Email is required",
      "string.empty": "Email is required",
    }),
});
